import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { MinutesView } from "@/components/le/MinutesView";
import { ChevronLeft } from "lucide-react";

export default function LeMinutesPreview() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    document.title = "BSM A/S — Referat (forhåndsvisning)";
    api.get(`/le/meetings/${id}/minutes-preview`).then((r) => setData(r.data)).catch((e) => setErr(formatApiError(e.response?.data?.detail)));
  }, [id]);
  if (err) return <div className="min-h-screen flex items-center justify-center text-sm text-[#A83232]" data-testid="le-preview-error">{err}</div>;
  if (!data) return <div className="min-h-screen flex items-center justify-center text-sm text-stone-400">Indlæser referat…</div>;
  const back = <Link to={`/ledelse/moede/${id}`} className="no-print inline-flex items-center gap-1 text-xs font-medium px-3 py-1.5 rounded-full border bg-white hover:bg-[#F3F1EC]" style={{ borderColor: "#EBE8E3", color: "#806B61" }} data-testid="le-preview-back"><ChevronLeft className="h-3.5 w-3.5" /> Tilbage til redigering</Link>;
  return <MinutesView data={data} isDraft={data.is_draft} embedded topLeft={back} />;
}
